import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { type AppState } from '../../app.store';
import { isBaseMapThemeDark } from '../mapStyles/mapSettingsMapStyles.helpers';
import { mapBaseMapStylesSelector } from '../mapStyles/mapSettingsMapStyles.selectors';
import type { ActiveMarkerIndicatorSettings } from './mapSettingsMarkers.state';

export const mapSettingsMarkersSelector = (state: AppState) => state.map.mapSettings.data.markers;
export const useMapSettingsMarkersSelector = () => useSelector(mapSettingsMarkersSelector);

const mapSettingsMarkersPanelSettingsSelector = (state: AppState) => state.map.mapSettings.data.markers.panelSettings;
export const useMapSettingsMarkersPanelSettingsSelector = () => useSelector(mapSettingsMarkersPanelSettingsSelector);

export const mapSettingsLabelMarkerOffsetsSelector = (state: AppState) => state.map.mapSettings.data.markers.labelMarkerOffsets;
export const useMapSettingsLabelMarkerOffsets = () => useSelector(mapSettingsLabelMarkerOffsetsSelector);

export const mapSettingsMarkerImagesSelector = (state: AppState) => state.map.mapSettings.data.markers.markerImages;
export const useMapSettingsMarkerImages = () => useSelector(mapSettingsMarkerImagesSelector);

const mapSettingsOpenLinksInSameWindowSelector = (state: AppState) => state.map.mapSettings.data.markers.openLinksInSameWindow;
export const useMapSettingsOpenLinksInSameWindow = () => useSelector(mapSettingsOpenLinksInSameWindowSelector);

const mapSettingsActiveMarkerIndicatorSettingsStateSelector = (state: AppState) => state.map.mapSettings.data.markers.activeMarkerIndicatorSettings;

export const mapSettingsActiveMarkerIndicatorSettingsSelector = createStateSelector([
  mapBaseMapStylesSelector,
  mapSettingsActiveMarkerIndicatorSettingsStateSelector,
], (baseMapStyles, activeMarkerIndicatorState): ActiveMarkerIndicatorSettings => {
  const mapTheme = baseMapStyles.theme;
  return ({
    color: isBaseMapThemeDark(mapTheme) ? activeMarkerIndicatorState.darkColor : activeMarkerIndicatorState.color,
    size: activeMarkerIndicatorState.size,
    speed: activeMarkerIndicatorState.speed,
    type: activeMarkerIndicatorState.type,
  });
});
export const useMapSettingsActiveMarkerIndicatorSettingsSelector = () => useSelector(mapSettingsActiveMarkerIndicatorSettingsSelector);

export const mapSettingsMarkerClusterDenseMarkersStateSelector = (state: AppState) => state.map.mapSettings.data.markers.clusterDenseMarkers;
export const mapSettingsMarkerUnclusterBelowNStateSelector = (state: AppState) => state.map.mapSettings.data.markers.unclusterBelowN;

export const mapSettingsUnstackMarkerStateSelector = (state: AppState) => state.map.mapSettings.data.markers.unstackMarkers;

export const mapSettingsStackMarkersWithPieChartsSelector = (state: AppState) => state.map.mapSettings.data.markers.stackedMarkersWPieCharts;
export const useMapSettingsStackMarkersWithPieChartsSelector = () => useSelector(mapSettingsStackMarkersWithPieChartsSelector);

const noPriorityMarkers: ReadonlyArray<SpreadsheetRowId> = [];
export const mapSettingsMarkersPriorityMarkersSelector = (state: AppState) => state.map.mapSettings.data.markers.priorityMarkers || noPriorityMarkers;
export const useMapSettingsMarkersPriorityMarkersSelector = () => useSelector(mapSettingsMarkersPriorityMarkersSelector);
